export default __webpack_public_path__ + "static/media/Brew of Acute Brawn.698b40de.jpg";